export const formatNumberTR = (value, fraction = 2) => {
  if (value === null || value === undefined || value === "") return "-";

  return Number(value).toLocaleString("tr-TR", {
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction,
  });
};
